<script setup lang="ts">
import { DIMENSION_IDS } from '@/constants'
import bar from '@/charts/home/bar'

const { codes } = useCountries()

const values = await apiFetch<Value[]>('values', {
    dimensionId: DIMENSION_IDS.GOV_RESPONSE,
    iso: unref(codes)
})

const container = ref<HTMLElement>()

const options = computed(() => {
    return bar(values)
})

useChart(container, options)
</script>

<template>
    <div ref="container" class="h-full" />
</template>